import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

import { SupportTicketListComponent } from './list-support-ticket.component';

import { CompanyAccountService } from '../../../company-account.service';
import { Observable } from 'rxjs';

const VMF_INSTANCE = 'https://vendasta-support.zendesk.com/agent/tickets/';

export type TicketInfo = {
  id: string;
  subject: string;
  description: string;
  status: string;
  requester: string;
  createdAt: string;
  channel: string;
  groupName: string;
  badgeColor: string;
  url: string;
  total: number;
};

@Component({
  selector: 'app-support-ticket',
  imports: [
    CommonModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    GalaxyButtonLoadingIndicatorModule,
    TranslateModule,
    GalaxyAlertModule,
    GalaxyFormFieldModule,
    GalaxyLoadingSpinnerModule,
    GalaxyPipesModule,
    SupportTicketListComponent,
  ],
  templateUrl: './support-ticket.component.html',
  styleUrls: ['../association-panel-base-styles.component.scss'],
})
export class SupportTicketComponent {
  private readonly accountCreationService = inject(CompanyAccountService);
  protected accountGroupId$ = this.accountCreationService.accountGroupId$;
  protected readonly partnerId$: Observable<string> = inject('PARTNER_ID' as any);

  @Input() openTicketsCount: number;

  openCreateTicket() {
    window.open(VMF_INSTANCE.concat('new/1'), '_blank');
  }
}
